import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { UploadComponent } from './upload.component';


@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
  ],
  declarations: [
    UploadComponent
  ],
  exports: [
    UploadComponent
  ]
})
export class UploadModule { }
